// Root of the console SPA: wires the auth seam, org state, toasts, and routing.
// While auth is resolving we show a splash; on auth failure, an error card. Once
// authenticated the layout + routed screens render.

import { Navigate, Route, Routes } from "react-router-dom"
import { AdminAuthProvider, useAdminAuth } from "./auth/AdminAuthContext.js"
import { Layout } from "./components/Layout.js"
import { fr } from "./i18n/fr.js"
import { PermissionsPage } from "./pages/PermissionsPage.js"
import { RolesPage } from "./pages/RolesPage.js"
import { TeamsPage } from "./pages/TeamsPage.js"
import { UserDetailPage } from "./pages/UserDetailPage.js"
import { UsersPage } from "./pages/UsersPage.js"
import { OrgProvider } from "./state/org.js"
import { Alert } from "./ui/primitives.js"
import { ToastProvider } from "./ui/toast.js"

function AuthGate() {
  const auth = useAdminAuth()

  if (auth.status === "loading") {
    return (
      <div className="center-screen">
        <span className="muted">{fr.app.loading}</span>
      </div>
    )
  }

  if (auth.status === "error") {
    return (
      <div className="center-screen">
        <div style={{ maxWidth: 420 }}>
          <Alert variant="error">
            {fr.app.authError} ({auth.message})
          </Alert>
        </div>
      </div>
    )
  }

  return (
    <OrgProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Navigate to="/roles" replace />} />
          <Route path="/roles" element={<RolesPage />} />
          <Route path="/permissions" element={<PermissionsPage />} />
          <Route path="/teams" element={<TeamsPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/users/:userId" element={<UserDetailPage />} />
          {/* Back-compat: the old dropdown route now redirects to the users list. */}
          <Route path="/user-roles" element={<Navigate to="/users" replace />} />
          <Route path="*" element={<Navigate to="/roles" replace />} />
        </Route>
      </Routes>
    </OrgProvider>
  )
}

export function App() {
  return (
    <AdminAuthProvider>
      <ToastProvider>
        <AuthGate />
      </ToastProvider>
    </AdminAuthProvider>
  )
}
